
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/testimonials",
      function () {
        return require("private-next-pages/profile/testimonials/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/testimonials"])
      });
    }
  